import cx from 'classnames';
import {
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    PHONE_VERIFICATION_SEND_SMS_EXPLANATION,
    PHONE_VERIFICATION_SEND_SMS_EXPLANATION_FREE,
    PHONE_VERIFICATION_SEND_SMS_EXPLANATION_price,
    PHONE_VERIFICATION_SEND_SMS_NOT_VALID_CZ_NUMBER,
    PHONE_VERIFICATION_SEND_SMS_NOT_VALID_NUMBER,
    PHONE_VERIFICATION_SEND_SMS_NOT_VALID_SK_NUMBER,
    PHONE_VERIFICATION_SEND_SMS_NUMBER_NEED_9_CHARS,
    PHONE_VERIFICATION_SEND_SMS_PHONE_NUMBER_CHARACTERS,
    PHONE_VERIFICATION_SEND_SMS_PHONE_NUMBER_LABEL,
    PHONE_VERIFICATION_SEND_SMS_SKIP,
    PHONE_VERIFICATION_SEND_SMS_SUBMIT,
    PHONE_VERIFICATION_SEND_SMS_TITLE_FORCED,
    PHONE_VERIFICATION_SEND_SMS_TITLE_MANUAL,
    PHONE_VERIFICATION_SEND_SMS_TITLE_NEWUSER,
    PHONE_VERIFICATION_YOUR_NEW_PHONE_NUMBER,
} from 'mk/autogenerated/translations/SendSmsTokenStep.d8025d44ab3238e86acf48460efb61c8'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import InputField from 'mk2/components/forms/InputField';
import SelectField from 'mk2/components/forms/SelectField';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Interpolate from 'mk2/components/Interpolate';
import { Mode, PHONE_FORM_NAME } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import { FormErrors } from 'redux-form';
import styles from './SendSmsTokenStep.mscss';

const prefixes = [
    '+1',       // United States and Canada
    '+20',      // Egypt
    '+30',      // Greece
    '+31',      // Netherlands
    '+32',      // Belgium
    '+33',      // France
    '+34',      // Spain
    '+36',      // Hungary
    '+350',     // Gibraltar
    '+351',     // Portugal
    '+352',     // Luxembourg
    '+353',     // Ireland
    '+354',     // Iceland
    '+355',     // Albania
    '+356',     // Malta
    '+357',     // Cyprus
    '+358',     // Finland
    '+359',     // Bulgaria
    '+370',     // Lithuania
    '+371',     // Latvia
    '+372',     // Estonia
    '+373',     // Moldova
    '+374',     // Armenia
    '+375',     // Belarus
    '+376',     // Andorra
    '+377',     // Monaco
    '+378',     // San Marino
    '+380',     // Ukraine
    '+381',     // Serbia
    '+382',     // Montenegro
    '+383',     // Kosovo
    '+385',     // Croatia
    '+386',     // Slovenia
    '+387',     // Bosnia and Herzegovina
    '+389',     // Macedonia
    '+39',      // Italy
    '+40',      // Romania
    '+41',      // Switzerland
    '+420',     // Czech Republic
    '+421',     // Slovakia
    '+423',     // Liechtenstein
    '+43',      // Austria
    '+44',      // United Kingdom
    '+45',      // Denmark
    '+46',      // Sweden
    '+47',      // Norway
    '+48',      // Poland
    '+49',      // Germany
    '+52',      // Mexico
    '+54',      // Argentina
    '+55',      // Brazil
    '+61',      // Australia
    '+64',      // New Zealand
    '+7',       // Russia
    '+81',      // Japan
    '+82',      // South Korea
    '+852',     // Hong Kong
    '+90',      // Turkey
    '+971',     // United Arab Emirates
    '+972',      // Israel
];

export const prefixesOptions = prefixes.map((prefix) => ({ value: prefix, label: prefix }));

const titles = {
    newuser: PHONE_VERIFICATION_SEND_SMS_TITLE_NEWUSER,
    manual: PHONE_VERIFICATION_SEND_SMS_TITLE_MANUAL,
    change: PHONE_VERIFICATION_SEND_SMS_TITLE_MANUAL,
    forced: PHONE_VERIFICATION_SEND_SMS_TITLE_FORCED,
    strollers: PHONE_VERIFICATION_SEND_SMS_TITLE_MANUAL,
};

interface OwnProps {
    className?: string;
    mode: Mode;
    canSkipToTokenVerification: boolean;
    initialValues: PhoneValues;

    onSendSmsToken(prefix: string, phoneNumber: string, mode: Mode);
    onSkip();
    onStoreEvent();
}

type Props = OwnProps;

interface PhoneValues {
    prefix: string;
    phoneNumber: string;
}

const validate = (values: PhoneValues) => {
    const errors: FormErrors<PhoneValues> = {};

    if (!values.phoneNumber) {
        errors.phoneNumber = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    } else if (!/^[\d\s]*$/.test(values.phoneNumber)) {
        errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_PHONE_NUMBER_CHARACTERS;
    } else {
        const phone = values.phoneNumber.replace(/\s/g, '');
        const prefix = values.prefix;

        if (prefix === '+421') {
            if (!/^09|^9/.test(phone)) {
                errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_NOT_VALID_SK_NUMBER;
            } else if (!/^(?:09|9)\d{8}$/.test(phone)) {
                errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_NUMBER_NEED_9_CHARS;
            }
        } else if (prefix === '+420') {
            if (!/^[67]/.test(phone)) {
                errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_NOT_VALID_CZ_NUMBER;
            } else if (phone.length !== 9) {
                errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_NUMBER_NEED_9_CHARS;
            }
        } else if ((phone.length < 6) || (phone.length > 16)) {
            errors.phoneNumber = PHONE_VERIFICATION_SEND_SMS_NOT_VALID_NUMBER;
        }
    }

    return errors;
};

class SendSmsTokenStep extends React.Component<Props & MKReduxFormInjectedProps<PhoneValues, Props>> {

    public componentDidMount() {
        this.props.onStoreEvent();
    }

    public render() {
        const { className, mode, canSkipToTokenVerification, onSkip, handleSubmit } = this.props;

        const title = titles[mode];

        return (
            <div className={cx(styles.SendSmsTokenStep, className)}>
                <h1 className={styles.SendSmsTokenStep__title}>
                    {interpolate(title)}
                </h1>

                <p className={styles.SendSmsTokenStep__description}>
                    {PHONE_VERIFICATION_SEND_SMS_EXPLANATION}
                    <br/>
                    <Interpolate
                        i18nKey={PHONE_VERIFICATION_SEND_SMS_EXPLANATION_price}
                        price={<strong>{PHONE_VERIFICATION_SEND_SMS_EXPLANATION_FREE}</strong>}
                    />
                </p>

                <form className={styles.SendSmsTokenStep__form} onSubmit={handleSubmit}>
                    <label htmlFor="phoneNumber" className={styles.SendSmsTokenStep__form__label}>
                        {mode !== 'change' && PHONE_VERIFICATION_SEND_SMS_PHONE_NUMBER_LABEL}
                        {mode === 'change' && PHONE_VERIFICATION_YOUR_NEW_PHONE_NUMBER}
                    </label>
                    <div className={styles.SendSmsTokenStep__form__phone}>
                        {/*
                            FIXME CeMi: this should be as a signle form <Field>,
                            because now validation and error messages are incorrectly displayed
                         */}
                        <SelectField
                            name="prefix"
                            options={prefixesOptions}
                            marginLeft={false}
                        />
                        <InputField
                            name="phoneNumber"
                            placeholder={ACTIVE_SERVER_ID === 201 ? '9xx xxx xxx' : ''}
                            type="tel"
                            dangerouslySetInnerHTMLForError
                        />
                    </div>

                    <SubmitButton
                        className={styles.SendSmsTokenStep__form__submit}
                        label={PHONE_VERIFICATION_SEND_SMS_SUBMIT}
                        icon="fa-paper-plane"
                        formName={PHONE_FORM_NAME}
                    />

                    {canSkipToTokenVerification && (
                        <div className={styles.SendSmsTokenStep__form__skip}>
                            <button className={styles.SendSmsTokenStep__form__skip__button} type="button" onClick={onSkip}>
                                {PHONE_VERIFICATION_SEND_SMS_SKIP}
                            </button>
                        </div>
                    )}
                </form>
            </div>
        );
    }
}

export default mkReduxFormNew<PhoneValues, Props>({
    formName: PHONE_FORM_NAME,
    onValidate: (values) => validate(values),
    onSave: (values, props) => props.onSendSmsToken(values.prefix, values.phoneNumber, props.mode),
    disableDirtyCheck: true,
})(SendSmsTokenStep);
